export default "__VITE_ASSET__DYe6KDJC__"